jQuery(document).ready(function(){
	jQuery(".wp-block-ic-blocks-accordeon").click(function(e){
		jQuery(this).toggleClass('active');
		if(jQuery(this).parent().hasClass('close-other') && jQuery(this).hasClass('active')) jQuery(this).parent().find('.wp-block-ic-blocks-accordeon.active').not(jQuery(this)).removeClass('active');
		e.stopPropagation();
	})
})
